import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import Utils from "@/utils/Utils";

const AdministrationRepository = RepositoryFactory.get("administration");

const state = {
  resume: {},
  reports: [],
  importEnded: false,
  importErrors: [],
  importFinish: false,
};

const getters = {
  getImportResume: (state) => {
    return state.resume;
  },
  getImportReports: (state) => {
    return state.reports;
  },
  getImportErrors: (state) => {
    return state.importErrors;
  },
  getImportEnded: (state) => {
    return state.importEnded;
  },
};

const actions = {
  createClass({ commit }, classes) {
    return AdministrationRepository.createClass(classes)
      .then((response) => {
        const results = response.data;
        commit("UPDATE_RESPONSE_RESUME", results.resume);
        commit("SET_IMPORT_REPORTS", results.report_filenames);
      })
      .catch((error) => {
        const errorObj = {
          serverSideError: true,
          response: error.response,
          message: `Erreur ${error.response.status}`,
        };
        commit("UPDATE_IMPORT_ERRORS", errorObj);
      })
      .finally(() => {
        commit("SET_IMPORT_ENDED", true);
      });
  },
  downloadReport(_, csv_file) {
    AdministrationRepository.downloadReport(csv_file.csv_filename).then(
      (response) => {
        Utils.download(csv_file.dl_filename, response.data);
      },
    );
  },
  resetState({ commit }) {
    commit("RESET_STATE", {});
  },
  annualPurge({ dispatch }) {
    AdministrationRepository.annualPurge().then(() => {
      dispatch(
        "notifications/addSuccess",
        {
          message: "Purge effectuée",
        },
        { root: true },
      );
    });
  },
};

const mutations = {
  UPDATE_RESPONSE_RESUME(state, stats) {
    state.resume["school"] = {
      name: stats.school,
      created: stats.school_created,
    };
    state.resume["students"] = {
      new: stats.new_students_count,
      existing: stats.existing_students_count,
    };
    state.resume["teachers"] = {
      new: stats.new_teachers_count,
      existing: stats.existing_teachers_count,
    };
    state.resume["classes"] = {
      new: stats.new_classes_count,
      existing: stats.existing_classes_count,
    };
  },
  SET_IMPORT_REPORTS(state, reports) {
    state.reports = reports;
  },
  SET_IMPORT_ENDED(state, value) {
    state.importEnded = value;
  },
  UPDATE_IMPORT_ERRORS(state, error) {
    state.importErrors.push(error);
  },
  START_CLASS_DISPATCH(state, className) {
    state.classDispatch[className] = false;
  },
  END_CLASS_DISPATCH(state, className) {
    state.classDispatch[className] = true;
  },
  RESET_CSV(state) {
    state.csv_data = [];
  },
  SET_FILENAME(state, fileName) {
    state.fileName = fileName;
  },
  RESET_STATE(state) {
    state.importErrors = [];
    state.importEnded = false;
    state.resume = {};
    state.reports = [];
    state.importFinish = false;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
